export default __webpack_public_path__ + "static/media/positions_ic.3e337d3b.svg";